function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Registrar-Icon"
}, React.createElement("g", null, React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#4B84FF",
  x: 0,
  y: 0,
  width: 16,
  height: 20,
  rx: 3
}), React.createElement("path", {
  d: "M20,15.8125 C20,15.928875 20.0525,16.04 20.1465,16.1218125 L22.1465,17.8718125 C22.244,17.957125 22.372,18 22.5,18 C22.628,18 22.756,17.957125 22.8535,17.8718125 L24.8535,16.1218125 C24.9475,16.04 25,15.928875 25,15.8125 L25,4 L20,4 L20,15.8125 Z",
  id: "Fill-4",
  fill: "#4B84FF"
}), React.createElement("path", {
  d: "M22,0 L23,0 C24.1045695,-2.02906125e-16 25,0.8954305 25,2 L25,3 L20,3 L20,2 C20,0.8954305 20.8954305,2.02906125e-16 22,0 Z",
  id: "Rectangle-6",
  fill: "#4B84FF"
}), React.createElement("rect", {
  id: "Rectangle-3",
  fill: "#FFFFFF",
  transform: "translate(6.000000, 5.000000) scale(1, -1) translate(-6.000000, -5.000000) ",
  x: 2,
  y: 4,
  width: 8,
  height: 2,
  rx: 1
}), React.createElement("rect", {
  id: "Rectangle-3-Copy",
  fill: "#FFFFFF",
  transform: "translate(6.000000, 9.000000) scale(1, -1) translate(-6.000000, -9.000000) ",
  x: 2,
  y: 8,
  width: 8,
  height: 2,
  rx: 1
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/BookPen.69a6717f.svg";
export { SvgComponent as ReactComponent };